import Controller, { OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangePatientSearchAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';
import { ClickEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ApplicationRoute } from '../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { BarcodeAPI, BarcodeData, PanelAPI } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { Patient } from '../../interfaces/exam-collect/patiente-data-props';
import { Inject } from '@odinjs/odin';

@Controller({
  component: ChangePatientSearchAliases.PATIENT_SEARCH_LAYOUT,
  fragment: FragmentNames.CHANGE_PATIENT_SEARCH,
})
class ChangePatientPersonSearchController extends BaseController {
  @Inject(ChangePatientSearchAliases.PANEL_MODAL)
  private readonly panelLoaderApi!: PanelAPI;

  @Inject(ChangePatientSearchAliases.BARCODE_COMPONENT)
  private readonly barcodeComponentApi!: BarcodeAPI;

  @OnMount({ target: ChangePatientSearchAliases.PATIENT_SEARCH_LAYOUT })
  onMountLayout(): void {
    const param = { module: 'changePatient' };
    HttpService.get(Endpoint.GENERATE_FUNCTION_LOG, param);

  }

  @OnReadSuccess({ target: ChangePatientSearchAliases.BARCODE_COMPONENT })
  onReadSucesstBarCode(event: ReadEvent<BarcodeData>): void {
    this.handleBarcodeRead(event,Endpoint.GET_PATIENT_LIST);
  }

  private handleBarcodeRead(event: ReadEvent<BarcodeData>, endpoint: string): void {
    const barcode = event.target as BarcodeAPI;
    const queryParams = {
      limit: 12,
      nrAtendimento: event.item.value.trim(),
      page: 0,
      readingMode: event.item.type,
    };
    barcode.setEnabled(false);
    this.panelLoaderApi.setVisible(true);

    HttpService.get(endpoint, queryParams)
      .then((resp) => {
        const body = resp.body as Patient[];
        barcode.setEnabled(true);
        if (body.length === 0) {
          this.panelLoaderApi.setVisible(false);
          barcode.setOpen(true);
        } else {
          barcode.close();
          this.getPatientAndRedirect(queryParams.nrAtendimento);
        }
      })
      .catch(() => {
        barcode.setEnabled(true);
        barcode.setOpen(true);
        this.panelLoaderApi.setVisible(false);
      });
  }

  @OnClick({ target: ChangePatientSearchAliases.PATIENT_FETCH_DECK })
  onCardClick(event: ClickEvent): void {
    const { cdPessoaFisica: cdPaciente, nrAtendimento } = event.value;

    const route = ApplicationRoute.CHANGE_PATIENT_PERSON_INFORMATION;

    applicationContext.redirect(route, {
      encounterId: String(nrAtendimento),
      patientId: cdPaciente,
    });
  }

  redirectToInformationBar(cdPaciente: string, nrAtendimento: string): void {
    const route = ApplicationRoute.CHANGE_PATIENT_PERSON_INFORMATION;
    try {
      this.panelLoaderApi.setVisible(false);
      applicationContext.redirect(route, {
        encounterId: nrAtendimento,
        patientId: cdPaciente,
      });
    } catch (err) {
      this.barcodeComponentApi.setOpen(true);
      this.panelLoaderApi.setVisible(false);
    }
  }

  getPatientAndRedirect(nrAtendimento: string): void {
    const queryParams = `?nrAtendimento=${nrAtendimento}&page=0&limit=12`;
    const route = `${Endpoint.GET_PATIENT_LIST}${queryParams}`;

    HttpService.get(route)
      .then((resp) => {
        const body = resp.body as Patient[];
        const cdPaciente = body[0].cdPessoaFisica;
        this.redirectToInformationBar(cdPaciente, nrAtendimento);
      })
      .catch(() => {
        this.panelLoaderApi.setVisible(false);
      });
  }
}

export default ChangePatientPersonSearchController;
